import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import * as io from 'socket.io-client';
import { ParseService } from '../parse/parse.service';
import { Subject, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { StorageConfiguration } from '../storage-setting/storage-configuration';
import { DateServiceService } from './dateservice';

@Injectable({
  providedIn: 'root'
})

export class SocketService {

  private socket: any;
  subject = new Subject<any>();
  updateMyStatus = new Subject();
  desktopTaskStatus = new Subject();
  contactList = new Subject<any>();
  firstname = this.parseService.instance.User.current() ? this.parseService.instance.User.current().get('firstName') : '';
  lastname = this.parseService.instance.User.current() ? this.parseService.instance.User.current().get('lastName') : '';

  constructor(
    private parseService: ParseService,
    private toastr: ToastrService,
    private storageConfiguration: StorageConfiguration,
    private dateService: DateServiceService,

  ) {

  }

  setupSocketConnection() {
    this.socket = io(environment.SOCKET_ENDPOINT, {
      reconnection: true, // whether to reconnect automatically
      reconnectionAttempts: Infinity, // number of reconnection attempts before giving up
      reconnectionDelay: 1000, // how long to initially wait before attempting a new reconnection
      reconnectionDelayMax: 5000, // maximum amount of time to wait between reconnection attempts. Each attempt increases the reconnection delay by 2x along with a randomization factor
      randomizationFactor: 0.5
    });
    this.socket.on('SOCKET_EMIT_EVENT', (event) => {
      this.socketHandling(event);
    })

    this.socket.on('disconnect', (disconnected) => {
    });

  }

  socketHandling(event: any) {
    let currentProfile = this.parseService.instance.User.current();
    let currentProfileId = currentProfile.get('profile').id;
    if (event.event_receiver.id == currentProfileId) {
      if (event.event_type != "UPDATE_CURRENT_TASK") this.getNotificationData();
      switch (event.event_type) {
        case 'NEW_TASK_ASSIGNED':
          this.socketNotification(event.message);
          break;
        case 'NEW_TASK_UNASSIGNED':
          this.socketNotification(event.message);
          break;
        case 'WATCHING_SCREENSHOT':
          if (event.isNotified) {
            let message = 'Your screenshots watched by ' + event.event_owner.name;
            this.socketNotification(message);
          }
          break;
        case 'WATCHING_TIMESHEET':
          if (event.isNotified) {
            let message = 'Your timesheet watched by ' + event.event_owner.name;
            this.socketNotification(message);
          }
          break;
        case 'NEW_TODO_ASSIGNED':
          this.socketNotification(event.message);
          break;
        case 'NEW_TODO_UNASSIGNED':
          this.socketNotification(event.message);
          break;
        case 'TODO_DELETED':
          this.socketNotification(event.message);
          break;
        case 'TODO_COMMENTS':
          this.socketNotification(event.message);
          break;
        case 'TODO_COMPLETED':
          this.socketNotification(event.message);
          break;
        case 'TASK_COMPLETION_EXCEEDED':
          this.socketNotification(event.message);
          break;
        case 'RESOURCE_STARTED_DAY':
          this.socketNotification(event.message);
          break;
        case 'RESOURCE_COMPLETED_DAY':
          this.socketNotification(event.message);
          break;
        case 'PROJECT_SWITCHED':
          this.socketNotification(event.message);
          break;
        case 'LEAVE_REQUEST':
          this.socketNotification(event.message);
          break;
        case 'APPROVE_REJECT_LEAVE':
          this.socketNotification(event.message);
          break;
        case 'PERMISSION_REQUEST':
          this.socketNotification(event.message);
          break;
        case 'PERMISSION_UPDATE':
          this.socketNotification(event.message);
          break;
        /**
         * * Update the user desktop status in the Header toolbar 
         */
        case 'DESKTOP_LOGIN':
          this.updateMyStatus.next(event);
          break;

        case 'UPDATE_CURRENT_TASK':
          this.desktopTaskStatus.next(event)
          break;
        default:
          break;
      }
    }
    let empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    if (empRole != 'Employee') {
      switch (event.event_type) {
        case 'RESOURCE_STARTED_DAY':
          this.contactList.next(event);
          break;
        case 'RESOURCE_COMPLETED_DAY':
          this.contactList.next(event);
          break;
        case 'RESOURCE_RESTARTED_DAY':
          this.contactList.next(event);
          break;
        case 'RESOURCE_WORK_TO_IDLE':
          this.contactList.next(event);
          break;
        case 'RESOURCE_IDLE_TO_WORK':
          this.contactList.next(event);
          break;
        default:
          break;
      }
    }

  }

  sendSocketEvent(eventName, eventData) {
    this.socket.emit(eventName, eventData);
  }

  getContactData(): Observable<any> {
    return this.contactList.asObservable();
  }

  getNotificationData(): Observable<any> {
    this.subject.next();
    return this.subject.asObservable();
  }

  socketNotification(message) {
    this.toastr.info(message);
  }

  async sendTimesheetNotification(id, pageType) {
    var queryProfile = new this.parseService.instance.Object('Profile');
    queryProfile.id = id;
    let sendSocket = {
      event_type: 'WATCHING_TIMESHEET',
      event_owner: {
        id: this.parseService.instance.User.current().get('profile').id,
        name: this.firstname + ' ' + this.lastname,
      },
      event_receiver: {
        id: id,
        name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
      },
      message: this.firstname + ' ' + this.lastname + ' watched your ' + pageType,
      event_created_Date: new Date(),
      initiated_source: 'web',
      pageType: pageType,
      isNotified: true
    }

    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let queryDataSettingResult = await query.find();

    let pageVisitClass = this.parseService.instance.Object.extend('PageVisit');
    let queryPageVisitClass = new this.parseService.instance.Query(pageVisitClass);
    let dateDifferents = this.dateService.startEndDateByDate(new Date());
    queryPageVisitClass.greaterThan('createdAt', dateDifferents[0]);
    queryPageVisitClass.lessThan('createdAt', dateDifferents[1]);
    queryPageVisitClass.equalTo('pageType', sendSocket.pageType);
    queryPageVisitClass.equalTo('receiverId', {
      __type: 'Pointer',
      className: 'Profile',
      objectId: sendSocket.event_receiver.id
    });
    queryPageVisitClass.descending('createdAt');
    queryPageVisitClass.equalTo('isNotified', true);
    let isNotified = true;
    let pageVisitResult = await queryPageVisitClass.find();
    if (pageVisitResult.length > 0) {
      let lastCreatedAt = pageVisitResult[0].get('createdAt');
      let currentTimeDifference = Math.ceil(((new Date().getTime()) - (new Date(lastCreatedAt).getTime())) / 1000);
      if (currentTimeDifference < queryDataSettingResult[0].get('notificationThreshold')) {
        isNotified = false;
      }
    }
    sendSocket.isNotified = isNotified;
    if (sendSocket.isNotified == true) {
      this.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
    }
  }

}
